
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 340 255","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M282 42v11H49v149h233v11H38V42h244zm29 131h-11v-73h11v73zM297 42v74h-11V42h11z","fill":"#7000BD"}}),_c('path',{attrs:{"d":"M340 38h-25V25H25v205h290v-54h25v79H0V0h340v38zm-29 188h-25v-50h25v50zm0-188h-25v-9h25v9z","fill":"#9D9D9D"}})])])
          )
        }
      }
    